import React from "react";
import Radium from "radium";
import moment from "moment-timezone";
import ReactPlayer from "react-player";
import { Dialog, FlatButton } from "material-ui";

const _Link = require("react-router").Link;
const Link = Radium(_Link);

import { DETAILS, CREDITS } from "../film.jsx";

import TagList from "./tag-list.jsx";
import InjectedTenantHTML from "./injected-tenant-html.jsx";
import { capitalize, intersperse } from "../../util";
import FilmPoster from "./film-poster.jsx";
import MarqueeFilmTicketsWidget from "./marquee/marquee-film-tickets-widget.jsx";

import LocalMoviesIcon from "material-ui/svg-icons/maps/local-movies";
import PlayIcon from "material-ui/svg-icons/av/play-circle-outline";

import { filterEventTagsByPass } from "../../utils/TagUtil.js";
import AppUtil from "../../utils/AppUtil.js";

const STYLES = {
  outer: {},
  innerWithPoster: {
    "@media (min-width: 661px)": {
      marginLeft: "calc(170px + 1em)"
    }
  },
  innerLeft: {
    float: "left",
    marginRight: "1em",
    width: 170
  },
  image: {
    "@media (max-width: 660px)": {
      display: "none"
    }
  },
  imageIcon: {
    height: 80,
    width: 80
  },
  imagePlaceholder: {
    height: 170
  },
  title: {
    margin: "0 0 0.5em"
  },
  description: {
    margin: "1em 0"
  },
  button: {
    border: "1px solid #ccc",
    lineHeight: "auto"
  },
  buttonLabel: {
    verticalAlign: 0
  },
  showings: {
    borderTop: "1px solid #ccc",
    paddingTop: "1em",
    marginTop: "1em",
    borderBottom: "1px solid #ccc",
    paddingBottom: "1.1em",
    marginBottom: "1em",
    color: "#9E9E9E"
  },
  showingsLabel: {
    fontWeight: "bold"
  },
  showingsLabelInstruction: {
    fontWeight: "normal",
    fontStyle: "italic"
  },
  tableSections: {
    fontSize: 14,
    lineHeight: "22px",
    display: "flex",
    flexWrap: "wrap"
  },
  tableSection: {
    flexBasis: "50%"
  },
  tableHeader: {
    margin: "0.25em 0"
  },
  tableLabel: {
    color: "#9e9e9e",
    display: "inline-block",
    fontStyle: "italic",
    width: 120,
    minWidth: 120,
    "@media (max-width: 660px)": {
      width: "auto",
      display: "block"
    }
  },
  table: {
    listStyle: "none",
    margin: 0,
    padding: 0
  },
  tableRow: {
    display: "flex",
    marginBottom: "0.25em",
    "@media (max-width: 660px)": {
      flexDirection: "column"
    }
  },
  dateLink: {
    color: "#9E9E9E",
    ":hover": {
      color: "#848484"
    }
  }
};

class FilmCard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showTrailer: false
    };
  }

  makeDataTable(data, source, expanded_credits) {
    return (
      <ul style={STYLES.table}>
        {Object.keys(source)
          .map(k => {
            if (k === "social_media") {
              if (!data["facebook"] && !data["twitter"] && !data["instagram"]) {
                return null;
              } else {
                return (
                  <li key={k} style={STYLES.tableRow}>
                    <div style={[STYLES.tableLabel]}>{source[k]}:</div>
                    {data["facebook"] ? (
                      <div className="no-translate">
                        <a
                          href={data["facebook"]}
                          target="_blank"
                          rel="noopener"
                          aria-label="Facebook"
                          style={{ marginLeft: 0, marginTop: 4 }}
                        >
                          <div
                            style={{
                              width: 16,
                              height: 16,
                              marginLeft: -4,
                              marginRight: 12
                            }}
                          >
                            <div aria-hidden="true">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 24 24"
                              >
                                <path d="M18.77 7.46H14.5v-1.9c0-.9.6-1.1 1-1.1h3V.5h-4.33C10.24.5 9.5 3.44 9.5 5.32v2.15h-3v4h3v12h5v-12h3.85l.42-4z" />
                              </svg>
                            </div>
                          </div>
                        </a>
                      </div>
                    ) : null}
                    {data["twitter"] ? (
                      <div
                        className="text-gray-300 no-translate"
                        style={{ float: "left" }}
                      >
                        <a
                          href={data["twitter"]}
                          target="_blank"
                          rel="noopener"
                          aria-label="Twitter"
                          style={{ marginLeft: 0, marginTop: 4 }}
                        >
                          <div
                            style={{
                              width: 16,
                              height: 16,
                              marginLeft: -4,
                              marginRight: 15
                            }}
                          >
                            <div aria-hidden="true">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 24 24"
                              >
                                <path d="M23.44 4.83c-.8.37-1.5.38-2.22.02.93-.56.98-.96 1.32-2.02-.88.52-1.86.9-2.9 1.1-.82-.88-2-1.43-3.3-1.43-2.5 0-4.55 2.04-4.55 4.54 0 .36.03.7.1 1.04-3.77-.2-7.12-2-9.36-4.75-.4.67-.6 1.45-.6 2.3 0 1.56.8 2.95 2 3.77-.74-.03-1.44-.23-2.05-.57v.06c0 2.2 1.56 4.03 3.64 4.44-.67.2-1.37.2-2.06.08.58 1.8 2.26 3.12 4.25 3.16C5.78 18.1 3.37 18.74 1 18.46c2 1.3 4.4 2.04 6.97 2.04 8.35 0 12.92-6.92 12.92-12.93 0-.2 0-.4-.02-.6.9-.63 1.96-1.22 2.56-2.14z" />
                              </svg>
                            </div>
                          </div>
                        </a>
                      </div>
                    ) : null}
                    {data["instagram"] ? (
                      <div
                        className="text-gray-300 no-translate"
                        style={{ float: "left" }}
                      >
                        <a
                          href={data["instagram"]}
                          target="_blank"
                          rel="noopener"
                          aria-label="Instagram"
                          style={{
                            marginLeft: 0,
                            marginRight: 12,
                            marginTop: 4
                          }}
                        >
                          <div
                            style={{
                              width: 16,
                              height: 16,
                              marginLeft: -4,
                              marginRight: 12
                            }}
                          >
                            <div aria-hidden="true">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 551.034 551.034"
                              >
                                <path
                                  class="logo"
                                  id="XMLID_17_"
                                  d="M386.878,0H164.156C73.64,0,0,73.64,0,164.156v222.722 c0,90.516,73.64,164.156,164.156,164.156h222.722c90.516,0,164.156-73.64,164.156-164.156V164.156 C551.033,73.64,477.393,0,386.878,0z M495.6,386.878c0,60.045-48.677,108.722-108.722,108.722H164.156 c-60.045,0-108.722-48.677-108.722-108.722V164.156c0-60.046,48.677-108.722,108.722-108.722h222.722 c60.045,0,108.722,48.676,108.722,108.722L495.6,386.878L495.6,386.878z"
                                />

                                <path
                                  id="XMLID_81_"
                                  d="M275.517,133C196.933,133,133,196.933,133,275.516 s63.933,142.517,142.517,142.517S418.034,354.1,418.034,275.516S354.101,133,275.517,133z M275.517,362.6 c-48.095,0-87.083-38.988-87.083-87.083s38.989-87.083,87.083-87.083c48.095,0,87.083,38.988,87.083,87.083 C362.6,323.611,323.611,362.6,275.517,362.6z"
                                />

                                <circle
                                  id="XMLID_83_"
                                  cx="418.306"
                                  cy="134.072"
                                  r="34.149"
                                />
                              </svg>
                            </div>
                          </div>
                        </a>
                      </div>
                    ) : null}
                  </li>
                );
              }
            } else if (!data[k]) {
              return null;
            }
            return (
              <li key={k} style={STYLES.tableRow}>
                <div style={[STYLES.tableLabel]}>
                  {k === "runtime" ? "Runtime" : source[k]}:
                </div>
                <div>
                  {data[k]}{" "}
                  {k === "runtime" && !isNaN(data[k]) ? "minutes" : null}
                </div>
              </li>
            );
          })
          .filter(x => !!x)
        }
        {expanded_credits && expanded_credits.length ? (
          <div>
          {expanded_credits.map(fc => {
            return (
              <li key={fc.id} style={STYLES.tableRow}>
                <div style={[STYLES.tableLabel]}>
                  {fc.label}:
                </div>
                <div>
                  {fc.value}
                </div>
              </li>
            )
          })}
          </div>
        ) : null}
      </ul>
    );
  }

  render() {
    let {
        film,
        currentEventId,
        hideTitle,
        hidePoster,
        eventLinkState,
        style,
        passes
      } = this.props,
      { router, muiTheme } = this.context;

    if (!film) {
      return null;
    }

    const filmLinkDestination = {
      pathname: `/films/${film.id}`,
      state: currentEventId && { fromEvent: true }
    };
    const stillsMode = this.context.tenant.film_guide_stills_mode;
    const image = stillsMode ? film.still_image : film.poster_image;

    // filter the events by tags and passes
    let filmEvents = film.events;
    if (this.context.tenant.virtual_protected_tag_list && filmEvents) {
      let passList = Object.values(passes || {});
      filmEvents = filterEventTagsByPass(
        film.events,
        this.context.tenant.virtual_protected_tag_list,
        passList
      );
    }

    const hasMultipleVirtualScreenings =
      filmEvents && filmEvents.filter(e => e.is_virtual).length > 1;

    return (
      <div style={style} className="Eventive--FilmCard FilmCard">
        {film.trailer_url ? (
          <Dialog
            open={this.state.showTrailer}
            bodyStyle={{ padding: 0, backgroundColor: "#000" }}
            className="Eventive--Dialog Eventive--Dialog--FilmTrailer"
            onRequestClose={() => this.setState({ showTrailer: false })}
          >
            {this.state.trailerError ||
            !ReactPlayer.canPlay(film.trailer_url) ? (
              <div
                style={{
                  padding: 30,
                  textAlign: "center",
                  backgroundColor: "#fff"
                }}
              >
                Oh dear!{" "}
                {this.state.trailerError ||
                  "The trailer could not be embedded."}{" "}
                Try going to the{" "}
                <a href={film.trailer_url} target="_blank">
                  original video
                </a>
                .
              </div>
            ) : (
              <div className="ReactPlayer--container">
                <ReactPlayer
                  url={film.trailer_url}
                  playing={this.state.showTrailer}
                  controls={true}
                  onError={e => {
                    if (
                      e &&
                      (!e.message ||
                        (e.message.indexOf("interact") === -1 &&
                          e.message.indexOf("interrupt") === -1 &&
                          e.message.indexOf("denied permission") === -1 &&
                          e.message.indexOf("operation was aborted") === -1))
                    ) {
                      this.setState({ trailerError: e.message || e });
                    }
                  }}
                  onPlay={() => this.setState({ trailerError: "" })}
                />
              </div>
            )}
          </Dialog>
        ) : null}
        <div style={STYLES.outer}>
          {!hidePoster ? (
            <Link to={filmLinkDestination}>
              <FilmPoster
                src={image}
                style={[
                  STYLES.innerLeft,
                  STYLES.image,
                  !image && STYLES.imagePlaceholder
                ]}
              >
                {!image ? <LocalMoviesIcon style={STYLES.imageIcon} /> : null}
              </FilmPoster>
            </Link>
          ) : null}
          <div style={!hidePoster ? STYLES.innerWithPoster : null}>
            {!hideTitle && <h2 style={STYLES.title}>{film.name}</h2>}
            {!AppUtil.isSundanceMobileMode(this.context.tenant) ? (
              <TagList
                style={{ marginTop: "-0.25em", marginBottom: "0.5em" }}
                tags={film.tags}
                tooltip={t => `View all films tagged "${t}"`}
                onClick={tag =>
                  router.push(`/films?filterTags[${tag.id}]=true`)
                }
              />
            ) : null}
            {film.description && (
              <InjectedTenantHTML
                style={STYLES.description}
                content={{ __html: film.description || film.short_description }}
              />
            )}
            <div style={{ width: "100%" }}>
              {currentEventId &&
              !AppUtil.isSundanceMobileMode(this.context.tenant) ? (
                <Link to={filmLinkDestination}>
                  <FlatButton
                    label="More details"
                    labelStyle={STYLES.buttonLabel}
                    style={STYLES.button}
                  />
                </Link>
              ) : null}
              {film.trailer_url ? (
                <FlatButton
                  icon={<PlayIcon style={{ verticalAlign: -7 }} />}
                  label="Play trailer"
                  labelStyle={STYLES.buttonLabel}
                  style={Object.assign(
                    {},
                    STYLES.button,
                    currentEventId && { marginLeft: 7 }
                  )}
                  onClick={() =>
                    this.setState({ showTrailer: true, trailerError: "" })
                  }
                />
              ) : null}
            </div>
            {!AppUtil.isSundanceMobileMode(this.context.tenant) ? (
              <div
                style={[
                  STYLES.showings,
                  {
                    borderTop: `1px solid ${muiTheme.palette.primary1Color}`,
                    borderBottom: `1px solid ${muiTheme.palette.primary1Color}`
                  }
                ]}
              >
                {this.context.tenant.marquee_enabled ? (
                  <div>
                    {filmEvents && filmEvents.length ? (
                      <div>
                        <MarqueeFilmTicketsWidget film={film} />
                      </div>
                    ) : (
                      <div>No upcoming showings are currently scheduled.</div>
                    )}
                  </div>
                ) : (
                  <div>
                    <div style={STYLES.showingsLabel}>
                      Showings{" "}
                      {!currentEventId ||
                      (filmEvents && filmEvents.length > 1) ? (
                        <span style={STYLES.showingsLabelInstruction}>
                          {" "}
                          – select to order tickets:
                        </span>
                      ) : null}
                    </div>
                    {filmEvents && filmEvents.length ? (
                      filmEvents
                        .sort((a, b) =>
                          a.start_time && b.start_time
                            ? a.start_time.localeCompare(b.start_time)
                            : a.id.localeCompare(b.id)
                        )
                        .map(e => {
                          if (e.is_virtual) {
                            const label = `${
                              e.is_dated &&
                              (moment(e.start_time) > Date.now() ||
                                moment(e.end_time) < Date.now())
                                ? `[Available ${moment(e.start_time)
                                    .twix(e.end_time)
                                    .format({
                                      monthFormat: "MMMM",
                                      implicitDate: false,
                                      implicitYear: false,
                                      implicitMinutes: false
                                    })}] `
                                : ""
                            }Stream online${
                              hasMultipleVirtualScreenings ? ` (${e.name})` : ""
                            }...`;
                            return (
                              <div key={e.id}>
                                <a
                                  key={e.id}
                                  href={`${this.context.appSettings.urls.virtual_festival}/play/${e.id}`}
                                  target="_blank"
                                  style={STYLES.dateLink}
                                >
                                  {label}
                                </a>
                              </div>
                            );
                          }

                          const label = `${moment(e.start_time).format(
                            "ddd, MMM Do, h:mm A"
                          )} ${e.venue.name ? `@ ${e.venue.name}` : ""}${
                            !e.tickets_available && e.ticket_buckets.length
                              ? ` (${this.context.tenant.event_sold_out_button_label.toUpperCase()})`
                              : ""
                          }`;
                          return (
                            <div key={e.id}>
                              {currentEventId === e.id ? (
                                <div style={{ fontStyle: "italic" }}>
                                  {label}
                                </div>
                              ) : (
                                <Link
                                  style={STYLES.dateLink}
                                  to={{
                                    pathname: `/schedule/${e.id}`,
                                    state: eventLinkState
                                  }}
                                >
                                  {label}
                                </Link>
                              )}
                            </div>
                          );
                        })
                    ) : (
                      <div>No showings scheduled, yet.</div>
                    )}
                  </div>
                )}
              </div>
            ) : null}
            <div style={STYLES.tableSections}>
              <div style={STYLES.tableSection}>
                {this.makeDataTable(film.details, DETAILS)}
              </div>
              <div style={STYLES.tableSection}>
                {this.makeDataTable(film.credits, CREDITS, film.expanded_credits)}               
              </div>
            </div>
          </div>
        </div>
        <div style={{ clear: "both" }} />
      </div>
    );
  }
}

FilmCard.contextTypes = {
  router: React.PropTypes.object,
  tenant: React.PropTypes.object,
  muiTheme: React.PropTypes.object,
  appSettings: React.PropTypes.object
};

export default Radium(FilmCard);



// WEBPACK FOOTER //
// ./src/app/components/partials/film-card.jsx